import VeeValidate from 'vee-validate';

import pt_BR from 'vee-validate/dist/locale/pt_BR';
import customDictionary from 'resources/extensions/vee-validate/custom-dictionary';

import CpfValidator from 'resources/extensions/vee-validate/cpf-validator';
import CnpjValidator from 'resources/extensions/vee-validate/cnpj-validator';

VeeValidate.Validator.extend('cpf', CpfValidator);
VeeValidate.Validator.extend('cnpj', CnpjValidator);

Vue.use(VeeValidate);

VeeValidate.Validator.localize(customDictionary);
VeeValidate.Validator.localize('pt_BR', pt_BR);
